<div mat-dialog-title>
  <div class="dialog-header">
    <div class="title">{{ isEdit ? 'Edit team' : 'Create new team' }}</div>
    <div class="actions">
      <mat-icon svgIcon="close" class="action-icon" (click)="close()"></mat-icon>
    </div>
  </div>
</div>
<div mat-dialog-content>
  <div class="create-record-content">

    <!-- Title -->
    <div class="row">
      <div class="title">Team</div>
      <input class="input" [(ngModel)]="name">
    </div>

    <!-- Permissions -->
    <div class="row">
      <div class="title">Permissions</div>
      <div class="permissions">
        <div class="permission-group" *ngFor="let group of permissionGroups">
          <div class="permission-group-title">{{ group.title }}</div>
          <label class="permission-item" *ngFor="let permission of group.permissions">
            <input
              type="checkbox"
              [checked]="isPermissionSelected(permission.key)"
              (change)="togglePermission(permission.key)">
            <span>{{ permission.label }}</span>
          </label>
        </div>
      </div>
    </div>

  </div>
</div>

<div mat-dialog-actions class="mat-dialog-actions dialog-actions">
  <div class="button secondary" (click)="close()">Cancel</div>
  <div class="button" [class.disabled]="!name.length" (click)="submit()">{{ isEdit ? 'Save' : 'Create' }}</div>
</div>
